import { render, staticRenderFns } from "./conversions-chart.vue?vue&type=template&id=f45f0368"
import script from "./conversions-chart.vue?vue&type=script&lang=js"
export * from "./conversions-chart.vue?vue&type=script&lang=js"
import style0 from "./conversions-chart.vue?vue&type=style&index=0&id=f45f0368&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports